import { Box, Skeleton, Paper } from "@mui/material";

const ReviewCardSkeleton = () => {
  return (
    <Paper
      sx={{
        p: 1.5,
        mb: 2,
        borderRadius: 2,
        border: "1px solid #eee",
      }}
    >
      <Box sx={{ display: "flex", gap: 2 }}>
        {/* 左カラム（画像・スコア想定） */}
        <Box sx={{ flex: "0 0 30%", minWidth: 200, maxWidth: 360 }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={160}
            sx={{ borderRadius: 2 }}
          />
          <Skeleton width="60%" height={32} sx={{ mt: 1 }} />
        </Box>

        {/* 右カラム（タイトル・説明想定） */}
        <Box sx={{ flex: "1 1 70%" }}>
          <Skeleton width="80%" height={28} />
          <Skeleton width="100%" height={20} sx={{ mt: 1 }} />
          <Skeleton width="95%" height={20} />
          <Skeleton width="90%" height={20} />
        </Box>
      </Box>
    </Paper>
  );
};

export default ReviewCardSkeleton;
